import * as MUIIcon from "react-icons/md";
import clsx from "clsx";
import React from "react";
interface IconTypes {
  /** https://react-icons.github.io/react-icons/icons?name=md */
  icon?: keyof typeof MUIIcon;
  style?: React.CSSProperties;
  fontSize?: string;
  className?: string;
  onClick?: (...param: any) => void;
}

export function Icon({
  icon = "MdKeyboardArrowLeft",
  className,
  ...rest
}: IconTypes) {
  const Tag = MUIIcon[icon] as React.ElementType;

  return (
    <Tag scale={5} className={clsx("text-gray-110", className)} {...rest} />
  );
}
